import { ItemBaseModel } from '../../item-base.model';
import { ErrorType } from './input-error.model';

export type InputItemType =
  | 'autocomplete'
  | 'checkbox'
  | 'checkboxes'
  | 'date'
  | 'dateRange'
  | 'email'
  | 'file'
  | 'number'
  | 'password'
  | 'passwordCreate'
  | 'quantityCounter'
  | 'radioButtons'
  | 'select'
  | 'selectTree'
  | 'tel'
  | 'text'
  | 'textarea';

export type InputValueType = unknown;
export type InputCustomValidators = Record<string, boolean>;
export type InputValidationErrors = Partial<Record<ErrorType, boolean>>;

export interface InputItemBaseModel extends ItemBaseModel {
  type: InputItemType;
  name: string;
  label?: string;
  labelInfo?: string;
  description?: string;
  placeholder?: string;
  value?: InputValueType;
  defaultValue?: InputValueType;
  validators?: InputCustomValidators;
  hint?: string;
  subscriptSizing?: 'fixed' | 'dynamic';
  additionalHint?: string;
}

export const isInputItem = (item: ItemBaseModel): item is InputItemBaseModel => {
  return (item as InputItemBaseModel).name !== undefined;
};
